/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChangeFailureStatusRuleDto,
    ChangeFailureStatusRuleDtoFromJSON,
    ChangeFailureStatusRuleDtoFromJSONTyped,
    ChangeFailureStatusRuleDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChangeFailureStatusRulesCommand
 */
export interface ChangeFailureStatusRulesCommand {
    /**
     * 
     * @type {Array<ChangeFailureStatusRuleDto>}
     * @memberof ChangeFailureStatusRulesCommand
     */
    rules?: Array<ChangeFailureStatusRuleDto> | null;
}

export function ChangeFailureStatusRulesCommandFromJSON(json: any): ChangeFailureStatusRulesCommand {
    return ChangeFailureStatusRulesCommandFromJSONTyped(json, false);
}

export function ChangeFailureStatusRulesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeFailureStatusRulesCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rules': !exists(json, 'rules') ? undefined : (json['rules'] === null ? null : (json['rules'] as Array<any>).map(ChangeFailureStatusRuleDtoFromJSON)),
    };
}

export function ChangeFailureStatusRulesCommandToJSON(value?: ChangeFailureStatusRulesCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rules': value.rules === undefined ? undefined : (value.rules === null ? null : (value.rules as Array<any>).map(ChangeFailureStatusRuleDtoToJSON)),
    };
}


